import axios from "axios";
import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import CustomPagination from "../../../Components/Utility/CustomPagination";
import { BookingSkeleton, BoxSkeleton } from "../../../Components/Utility/Skeletons";
import { fetchCmsMetaData } from "../../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../../Components/Utility/setMetaTags";

function HostExperience() {
  const token = localStorage.getItem("authToken");
  const [dashboardData, setDashboardData] = useState(null);
  const [todayBookings, setTodayBookings] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 5;
const [meta,setMeta] = useState();
  const [loadingDashboard, setLoadingDashboard] = useState(true);
const [loadingBookings, setLoadingBookings] = useState(true);


  useEffect(() => {
    // 🔹 Fetch dashboard data based on currency ID
    const fetchDashboard = async (currencyId) => {
      try {
        setLoadingDashboard(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/host/dashboard?currency_id=${currencyId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (res.data) {
          setDashboardData(res.data);
        }
      } catch (err) {
        console.error("Failed to fetch dashboard data", err);
      }finally {
    setLoadingDashboard(false);
  }
    };

    // 🔹 Fetch today's bookings
    const fetchTodayBookings = async () => {
      try {
        setLoadingBookings(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/host/today-bookings?page=${currentPage}&perPage=${limit}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (res.data?.status) {
          setTodayBookings(res.data.data);
          // ✅ Set pagination if available
          if (res.data.pagination) {
            setCurrentPage(res.data.pagination.current_page);
            setTotalPages(res.data.pagination.last_page);
          } else if (res.data.meta) {
            // in case your API uses "meta"
            setCurrentPage(res.data.meta.current_page);
            setTotalPages(res.data.meta.last_page);
          }
        } else {
          setTodayBookings([]);
        }
      } catch (err) {
        console.error("Failed to fetch today bookings", err);
        setTodayBookings([]);
      }finally {
    setLoadingBookings(false);
  }
    };

    // ✅ Utility to get selected currency ID
    const getCurrencyId = () => {
      const selectedCurrency = JSON.parse(
        localStorage.getItem("selectedCurrency")
      );
      return selectedCurrency?.id || "6"; // default to ID 6 if not set
    };

    let currentCurrencyId = getCurrencyId();

    // First load
    fetchDashboard(currentCurrencyId);
    fetchTodayBookings();

    // 🔹 Detect cross-tab localStorage currency change
    const handleStorageChange = (e) => {
      if (e.key === "selectedCurrency") {
        const updatedCurrency = JSON.parse(e.newValue);
        const newCurrencyId = updatedCurrency?.id || "6";
        if (newCurrencyId !== currentCurrencyId) {
          window.location.reload(); // 🔁 simple reload to refresh data and layout
        }
      }
    };
    window.addEventListener("storage", handleStorageChange);

    // 🔹 Detect same-tab currency change using interval
    const localCheck = setInterval(() => {
      const local = getCurrencyId();
      if (local !== currentCurrencyId) {
        window.location.reload(); // ✅ refresh immediately
      }
    }, 1200); // checks every 1.2s

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(localCheck);
    };
  }, [token, currentPage]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [currentPage]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const formatTo12Hour = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes, seconds] = timeString.split(":");
    const date = new Date();
    date.setHours(hours, minutes, seconds);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getBookingStatusText = (booking) => {
    const { cancel_status, cancel_by } = booking;

    // 🟡 If cancel_status is null → user requested cancellation
    if (cancel_status === null) {
      return "Booking Confirmed";
    }

    // 🔴 If cancel_status = 1 and cancel_by = 1 → user cancelled booking
    if (cancel_status === 0 && cancel_by === 1) {
      return "Cancel Booking";
    }

    // 🔴 If cancel_status = 1 and cancel_by = 1 → user cancelled booking
    if (cancel_status === 1 && cancel_by === 1) {
      return "Booking Cancelled ";
    }

    // 🔴 If cancel_status = 1 and cancel_by = 2 → host cancelled booking
    if (cancel_status === 1 && cancel_by === 2) {
      return "Booking Cancelled";
    }

    // 🟠 If cancel_status = 0 and cancel_by = 2 → host requested cancellation (pending)
    if (cancel_status === 0 && cancel_by === 2) {
      return "Pending";
    }
  };

  useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("dashboard");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <>
      <section className="ser_v_araeea allpages dashboardpgs al_bootm_spance">
         <SetMetaTags
        title= {meta?.meta_title || "Dashboard | Weyfarin"}
        description={meta?.meta_description || "Dashboard | Weyfarin"}
      
      />
        <div className="container">
          <div className="row">
             {loadingDashboard
    ? Array.from({ length: 4 }).map((_, i) => (
        <div className="col-lg-3 col-sm-6 mt_on_tabs" key={i}>
          <BoxSkeleton />
        </div>
      ))
    : (
            
<>
            <div className="col-lg-3 col-sm-6 mt_on_tabs">
              <div className="ds_box_area" onClick={() => navigate("/payment?tab=earning")}>
                <h3>
                  <span className="mg_bexx">
                    <img
                      src="images/cln_icon_sm.png"
                      className="ic_mngss"
                      alt=""
                    />
                  </span>{" "}
                  <span className="titlss">Total Earning</span>
                </h3>
                <p>
                  {dashboardData?.total_fees_collected || 0}{" "}
                  {dashboardData?.currency?.currency || "AUD"}
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 mt_on_tabs">
              <div className="ds_box_area" onClick={() => navigate("/payment?tab=refund")}>
                <h3>
                  <span className="mg_bexx">
                    <img
                      src="images/refund.png"
                      className="ic_mngss"
                      alt=""
                    />
                  </span>{" "}
                  <span className="titlss">Total Refund </span>
                </h3>
                <p>
                  {dashboardData?.total_refunds || 0}{" "}
                  {dashboardData?.currency?.currency || "AUD"}
                </p>
              </div>
            </div>

            
            <div className="col-lg-3 col-sm-6 mt_on_tabs ">
              <div
                className="ds_box_area"
                onClick={() => navigate("/payment?tab=payout")}
              >
                <h3>
                  <span className="mg_bexx">
                    <img
                      src="images/payout.png"
                      className="ic_mngss"
                      alt=""
                    />
                  </span>{" "}
                  <span className="titlss">Total Payout</span>
                </h3>
                <p>{dashboardData?.hostpayout || 0}  {dashboardData?.currency?.currency || "AUD"}</p>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 mt_on_tabs ">
              <div className="ds_box_area platform_cursor">
                <h3>
                  <span className="mg_bexx">
                    <img
                      src="/images/listing_total.png"
                      className="ic_mngss"
                      alt=""
                    />
                  </span>{" "}
                  <span className="titlss">Platform Fees</span>
                </h3>
                <p>
                  {dashboardData?.total_commission_margin || 0}{" "}
                  {dashboardData?.currency?.currency || "AUD"}
                </p>
              </div>
            </div>


            <div className="col-lg-3 col-sm-6 mt_on_tabs mt-3">
              <div
                className="ds_box_area"
                onClick={() => navigate("/payment")}
              >
                <h3>
                  <span className="mg_bexx">
                    <img
                      src="images/booking.png"
                      className="ic_mngss"
                      alt=""
                    />
                  </span>{" "}
                  <span className="titlss">Total Bookings</span>
                </h3>
                <p>{dashboardData?.total_bookings || 0}</p>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6 mt_on_tabs mt-3">
              <div className="ds_box_area" onClick={() => navigate("/listing")}>
                <h3>
                  <span className="mg_bexx">
                    <img
                      src="images/platformfee.png"
                      className="ic_mngss"
                      alt=""
                    />
                  </span>{" "}
                  <span className="titlss">Total Listings</span>
                </h3>
                <p>{dashboardData?.total_experience || 0}</p>
              </div>
            </div>

            </>
    )}

            

           
          </div>

          <div className="ds_listsng">
            {loadingBookings ? (
    Array.from({ length: 3 }).map((_, i) => <BookingSkeleton key={i} />)
  ) : todayBookings.length === 0 ? (
    <div className="nodata">
    <p>No bookings for today</p>
    </div>
  ) : (
            <>
            <h3>Today’s Bookings</h3>

            {todayBookings.length === 0 ? (
              <p>No bookings for today</p>
            ) : (
              <>
                {todayBookings.map((booking) => (
                  <div className="main_listst" key={booking.id}>
                    <div className="tp_area_cnt">
                      <div className="undr_litst booking_st">
                        {/* Experience Name: if API gives experience_name directly, use that */}
                        <h6>{booking.experience_title}</h6>

                        {/* You can add rating if your API gives it, else remove */}
                        <span className="rveuss">
                          {Number(booking.avg_review_rating).toFixed(1)}/5{" "}
                          <span className="tx golden_tx">
                            <i className="fa fa-star"></i>
                          </span>
                        </span>

                        {/* <span className="tx green_tx">Today</span> */}
                        {/* <NavLink
                          to={`/host-experience-detail/${booking.booking_id}`}
                          state={{ experienceId: booking.experience_id }}
                          className="tx green_tx"
                        >
                          View Details
                        </NavLink> */}

                        <p className={`booking_status btn-sm p-0 pl-2 pr-2 mb-0 ${
    booking.cancel_status === 1
      ? "btn-danger" // Cancelled
      : booking.cancel_status === null
      ? "btn-success" // Pending
      : booking.cancel_status === 0 && booking.cancel_by === 2
      ? "btn-warning" // Cancel requested by user
      : booking.cancel_status === 0 && booking.cancel_by === 1
      ? "btn-warning" // Cancel requested by host
      : "btn-success" // Confirmed
  }`}>
                          {/* <strong
                            style={{
                              color:
                                booking.cancel_status === 1
                                  ? "white"
                                  : booking.cancel_status === null
                                  ? "white"
                                  : booking.cancel_status === 0 &&
                                    booking.cancel_by === 2
                                  ? "white"
                                  : booking.cancel_status === 0 &&
                                    booking.cancel_by === 1
                                  ? "white"
                                  : "white",
                            }}
                          >
                            {getBookingStatusText(booking)}
                          </strong> */}

                          <strong className="text-white strong_page">
    {getBookingStatusText(booking)}
  </strong>
                        </p>
                      </div>

                      {/* <div className="btm_tx">
            <p>
              Booking ID : <strong>{booking.booking_id}</strong>
            </p>
          </div> */}

                      <div className="btm_tx">
                        <p>
                          Booking ID : <strong>{booking.booking_id}</strong>
                        </p>
                      </div>
                    </div>

<div class="main_bothssse">
                    <div className="btm_txund">
                      <p>
                        <span className="dtss">Booked By</span> Experience Slot
                      </p>
                      <h6>
                        <span className="dtss">
                          {booking.user_first_name} {booking.user_last_name}
                        </span>{" "}
                        {/* {booking.booking_date} , {booking.booking_from_time}-
            {booking.booking_to_time} */}
                        {booking.booking_date},{" "}
                        {formatTo12Hour(booking.booking_from_time)} -{" "}
                        {formatTo12Hour(booking.booking_to_time)}
                      </h6>
                    </div>

                    <div className="viw_detlss">
                        <NavLink
                          to={`/host-experience-detail/${booking.booking_id}`}
                          state={{ experienceId: booking.experience_id }}
                          className="btnnss"
                        >
                          View Detail
                        </NavLink>
                      </div>
                      </div>
                  </div>
                ))}

                <CustomPagination
                  currentPage={currentPage}
                  lastPage={totalPages}
                  onPageChange={handlePageChange}
                />
              </>
            )}
            </>
  )}
          </div>

          {/* <div className="ds_listsng">
	    <h3>Today’s Bookings</h3>
		
		<div className="main_listst">
		 <div className="tp_area_cnt">
		  <div className="undr_litst">
		   <h6>Architectural Tour of Delhi City</h6> 
		   <span className="rveuss">4.9/5 <span className="tx golden_tx"><i class="fa fa-star"></i></span></span> 
		   <span className="tx green_tx">Today</span>
		  </div>
		  <div className="btm_tx">
		   <p>Booking ID : <strong>WF97879244</strong></p>
		  </div>
		 </div> 
		 <div className="btm_txund">
		  <p><span className="dtss">Booked By</span>       Experience Slot</p>
		  <h6><span className="dtss">Mr. Oran Lee</span>  23-09-2015 , 10:00-11:00pm</h6>
		 </div>
		</div>
		
		
		<div className="main_listst">
		 <div className="tp_area_cnt">
		  <div className="undr_litst">
		   <h6>Architectural Tour of Delhi City</h6> 
		   <span className="rveuss">4.9/5 <span className="tx golden_tx"><i class="fa fa-star"></i></span></span> 
		   <span className="tx green_tx">Today</span>
		  </div>
		  <div className="btm_tx">
		   <p>Booking ID : <strong>WF97879244</strong></p>
		  </div>
		 </div> 
		 <div className="btm_txund">
		  <p><span className="dtss">Booked By</span>       Experience Slot</p>
		  <h6><span className="dtss">Mr. Oran Lee</span>  23-09-2015 , 10:00-11:00pm</h6>
		 </div>
		</div>


		<div className="main_listst">
		 <div className="tp_area_cnt">
		  <div className="undr_litst">
		   <h6>Architectural Tour of Delhi City</h6> 
		   <span className="rveuss">4.9/5 <span className="tx golden_tx"><i class="fa fa-star"></i></span></span> 
		   <span className="tx green_tx">Today</span>
		  </div>
		  <div className="btm_tx">
		   <p>Booking ID : <strong>WF97879244</strong></p>
		  </div>
		 </div> 
		 <div className="btm_txund">
		  <p><span className="dtss">Booked By</span>       Experience Slot</p>
		  <h6><span className="dtss">Mr. Oran Lee</span>  23-09-2015 , 10:00-11:00pm</h6>
		 </div>
		</div>
		
		
	   </div> */}
        </div>
      </section>
    </>
  );
}

export default HostExperience;
